module.exports = "<div class=\"footer\">\n    <p class=\"footerText\">Copyright © 2018 Combitech</p>\n</div>"